angular.module('impactx.productgroup').controller('ViewExtensionEditPRGController', [
    '$scope',
    'TranslationService',
    'dataGen',
    'ToastService',
    'selectedListItems',
    'ToolbarService',
    'BackService',
    ViewExtensionEditPRGController
]);

function ViewExtensionEditPRGController($scope, TranslationService, dataGen, ToastService, selectedListItems, ToolbarService, BackService)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.deleteLabel = TranslationService.get("delete");
    $scope.requiredLabel = TranslationService.get("required");

    var self = this;
    var item;

    self.addPriceRule = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/productgroup/viewextension/pricerule/add").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            BackService.back();
        });
    };

    self.deletePriceRule = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/productgroup/viewextension/pricerule/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            BackService.back();
        });
    };

    self.noPriceRule = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/productgroup/viewextension/pricerule/norule").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            BackService.back();
        });
    };

    function getData() {
        item = selectedListItems.getFirstSelectedItem();
        dataGen.getData($scope, {catId: item.catId, vcatId: item.vcatId, prgId: item.prgId}, "/productgroup/viewextension/pricerule/view").then(function () {
            defineButtons();
        });
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.saveLabel,
                action: self.addPriceRule,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                }
            },
            {
                label: $scope.trns.deletePriceRule,
                action: self.deletePriceRule,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.noPriceRule,
                action: self.noPriceRule,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    getData();
}